import type { FilterSearchConfigMap } from "app/pages/sales-intelligence/modules/advanced-search-filtering/services/filter-search-service/types";
import advancedFilteringI18nKeys from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/i18n";
import leadsSearchFiltersI18nKeys from "app/pages/sales-intelligence/modules/leads-search-filters/utils/i18n";

import type { ContactsSearchFilterKey } from "../types/misc";

/**
 * Only filters that benefit from additional search terms are listed here.
 * Filters not in this config are still fully searchable by their translated label.
 */
export const createContactsFiltersSearchConfig = (): FilterSearchConfigMap<ContactsSearchFilterKey> => ({
    employeeLocation: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("workforce"),
                advancedFilteringI18nKeys.searchKeyword("staff"),
                advancedFilteringI18nKeys.searchKeyword("location"),
                advancedFilteringI18nKeys.searchKeyword("geography"),
                advancedFilteringI18nKeys.searchKeyword("region"),
            ],
        },
        autoExpandOnSearchMatch: true,
    },
    employeeProfiles: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("role"),
                advancedFilteringI18nKeys.searchKeyword("seniority"),
                advancedFilteringI18nKeys.searchKeyword("workforce"),
                advancedFilteringI18nKeys.searchKeyword("staff"),
                advancedFilteringI18nKeys.searchKeyword("profile"),
            ],
        },
    },
    contactDetails: {
        keywords: {
            literals: ["LinkedIn"],
        },
    },
    contactsPerCompanyFilter: {
        keywords: {
            literals: ["leads"],
        },
    },
    useContactFiltersForCompanies: {
        keywords: {
            translationKeys: [leadsSearchFiltersI18nKeys.filterGroupLabel("applyContactFilters")],
        },
    },
});
